import { UpdateUserBody, UpdateUserForm } from '@shared/dto/users.dto'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useAuthStore } from '../useAuthStore'
import axiosClient from '../useAxios'

export const useUserUpdateMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationKey: ['user', 'update'],
    mutationFn: async (data: {
      user: UpdateUserBody | UpdateUserForm
      userId: string
    }): Promise<void> => {
      await axiosClient.patch(`/users/${data.userId}`, data.user)
    },
    onSuccess: async (_, variables) => {
      await queryClient.invalidateQueries({
        queryKey: ['users', variables.userId]
      })
    }
  })
}

export const useJoinCompanyMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationKey: ['user', 'join-company'],
    mutationFn: async (data: {
      userId: string
      companyId: string
    }): Promise<void> => {
      await axiosClient.post(`/users/${data.userId}/companies`, {
        companyId: data.companyId
      })
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['companies', 'not-associated']
      })
    }
  })
}

export const useDeleteUserMutation = () => {
  const queryClient = useQueryClient()
  const { clearAuth } = useAuthStore()
  return useMutation({
    mutationKey: ['user', 'delete'],
    mutationFn: async (data: {
      accessToken: string
      userId: string
    }): Promise<void> => {
      await axiosClient.delete(`/users/${data.userId}`, {
        data: {
          accessToken: data.accessToken
        }
      })
    },
    onSuccess: async (_, variables) => {
      clearAuth()
      await queryClient.invalidateQueries({
        queryKey: ['users', variables.userId]
      })
    }
  })
}
